import { render } from "./DiagramSidebar.vue?vue&type=template&id=6dc4c740&scoped=true"
import script from "./DiagramSidebar.vue?vue&type=script&lang=js"
export * from "./DiagramSidebar.vue?vue&type=script&lang=js"

import "./DiagramSidebar.vue?vue&type=style&index=0&id=6dc4c740&lang=css"
import "./DiagramSidebar.vue?vue&type=style&index=1&id=6dc4c740&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc4c740"]])

export default __exports__